import {HealthRating} from "../domain/HealthRating";
import {AccountComponentRatings} from "../domain/AccountComponentRatings";
import {Box, Button, Stack, Typography} from "@mui/material";
import {healthRatingLightColor} from "../util/HealthStatusUtils";
import React from "react";
import {AccountComponentDisplay} from "./AccountComponentDisplay";
import {AccountCircle, Business, HorizontalRule} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import {useTranslation} from "react-i18next";
import {AccountComponent} from "../domain/AccountComponent";
import {RuleReport} from "../domain/RuleReport";

interface AccountHealthDisplayProps {
    overallHealth: HealthRating | undefined;
    componentHealth: AccountComponentRatings | undefined;
    rules: Array<RuleReport> | undefined;
    lookupString: string;
    handleClear: any;
}

export default function AccountHealthDisplay({overallHealth, componentHealth, rules, lookupString, handleClear} : AccountHealthDisplayProps) {
    const {t, i18n} = useTranslation();

    return (
            <Grid container>
                <Grid size={12}>
                    <Box sx={{color:'primary.contrastText', bgcolor: 'primary.main', p: 1}}>
                        <Typography variant={"h6"}>{t('domain.common.accountHealth')}: {t(`domain.accountHealth.${overallHealth}`)}</Typography>
                    </Box>
                </Grid>
                <Grid
                    size={12}
                    bgcolor={healthRatingLightColor(overallHealth ?? HealthRating.UNKNOWN)}
                    sx={{p: 2}}>
                <Grid/>
                <Grid size={12} sx={{p: 2}}>
                        <Stack direction="row" alignItems={"center"} justifyContent={"center"} spacing={2}>
                           <Stack alignItems={"center"}>
                               <AccountCircle fontSize={"large"}/>
                               <Typography>{lookupString}</Typography>
                           </Stack>

                           <HorizontalRule/>
                            <AccountComponentDisplay
                                displayName={t('domain.common.signIn')}
                                component={AccountComponent.APP_SIGN_IN}
                                rules={rules}
                                rating={componentHealth?.APP_SIGN_IN ?? HealthRating.UNKNOWN} />
                            <HorizontalRule/>
                            <AccountComponentDisplay
                                displayName={t('domain.common.identityProvider')}
                                component={AccountComponent.IDENTITY_PROVIDER}
                                rules={rules}
                                rating={componentHealth?.IDENTITY_PROVIDER ?? HealthRating.UNKNOWN} />
                           <HorizontalRule/>
                           <AccountComponentDisplay
                               displayName={t('domain.common.regionalAccount')}
                               component={AccountComponent.REGIONAL}
                               rules={rules}
                               rating={componentHealth?.REGIONAL ?? HealthRating.UNKNOWN} />
                           <HorizontalRule/>
                           <Stack alignItems={"center"}>
                               <Business fontSize={"large"}/>
                               <Typography>WFE</Typography>
                           </Stack>
                       </Stack>
                    </Grid>
                    <Grid size={12} display='flex' justifyContent='right'>
                        <Button onClick={handleClear} variant={"contained"}>{t('common.clear')}</Button>
                    </Grid>
                </Grid>
            </Grid>

    );
}